// app/javascript/dashboard/routes/dashboard/bots/bots.routes.js
//
// B.3-v2: acomoda duas coisas aqui, fora da arvore de /settings/:
//
//   1. Rota full-screen do BUILDER (nova): `bot_flow_editor`
//        /app/accounts/:accountId/bots/:botId/flow
//      Essa rota fica fora de /settings/ — nao herda SettingsWrapper/max-w,
//      ocupa a tela inteira (so a sidebar primaria do Chatwoot fica visivel).
//
//   2. Redirects de URLs antigas pra nao quebrar bookmarks:
//        /app/accounts/:accountId/bots        -> settings_bots_index
//        /app/accounts/:accountId/bots/new    -> settings_bots_index
import { frontendURL } from '../../../helper/URLHelper';

const FlowBuilder = () =>
  import('../settings/bots/flowBuilder/Index.vue');

export default {
  routes: [
    // B.3-v15: rota full-screen do builder em MODO CREATE (sem botId).
    // Usado quando usuario clica "Novo bot" - builder carrega em branco,
    // so persiste no backend no primeiro Save/Publish. Evita rascunhos
    // "Novo bot" vazios poluindo a lista quando usuario fecha sem salvar.
    {
      path: frontendURL('accounts/:accountId/bots/new/flow'),
      name: 'bot_flow_new',
      component: FlowBuilder,
      meta: {
        permissions: ['administrator'],
        hideSidebar: true,
        hideChatList: true,
      },
    },
    // Rota full-screen do builder em MODO EDIT (botId ja existe no banco)
    {
      path: frontendURL('accounts/:accountId/bots/:botId/flow'),
      name: 'bot_flow_editor',
      component: FlowBuilder,
      meta: {
        permissions: ['administrator'],
        hideSidebar: true,
        hideChatList: true,
      },
    },
    // Redirects de URLs legacy
    {
      path: frontendURL('accounts/:accountId/bots'),
      name: 'bots_index',
      redirect: to => ({
        name: 'settings_bots_index',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/bots/new'),
      name: 'bots_new',
      redirect: to => ({
        name: 'bot_flow_new',
        params: { accountId: to.params.accountId },
      }),
    },
  ],
};
